'use client';

import Link from 'next/link';
import { CustomEventName, GTMConstants, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

type ReadMoreLinkProps = {
  title: string;
  newsId: number;
};

const onClick = (title: string, newsId: number) => {
  sendGTM({
    [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_NEWS,
    [GTMEventKey.SECTION]: `${GTMConstants.SECTION_PLACEHOLDER}_延伸閱讀`,
    [GTMEventKey.CLICK_ITEM]: `${newsId}_${title}`
  });
};

const ReadMoreLink: React.FC<ReadMoreLinkProps> = ({ newsId, title }) => {
  return (
    <Link prefetch={false} href={`/news/id/${newsId}`} onClick={() => onClick(title, newsId)}>
      {title}
    </Link>
  );
};

export default ReadMoreLink;
